<template>
    <div>
        <div v-if="loading">
            <div class="card">
                <div class="card-body d-flex justify-content-center">
                    <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
            </div>
        </div>
        <div
            class="card mb-2 pointer hover"
            :class="{ 'border-primary my-3': currentTask == index }"
            v-for="(task, index) in tasks"
            :key="index"
            @click="currentTask = index"
            v-else
        >
            <div class="card-body p-3">
                <div class="row align-items-center flex-md-nowrap no-gutters">
                    <div class="col">
                        <div class="row">
                            <div class="col-auto text-muted small pr-3">
                                <status-badge
                                    :icon-only="true"
                                    :status="task.status"
                                ></status-badge>
                            </div>
                            <div class="col-auto col-md-3">
                                <div>{{ task.startDate | moment("calendar") }}</div>
                                <span class="small text-muted">{{ task.dueDate | moment("calendar") }}</span>
                            </div>
                            <div class="col-12 col-md-3 mt-3 mt-md-0">
                                <div
                                    class="customer-card"
                                    v-if="task.customer && task.customer._id && !hideCustomer"
                                    @click.stop="openPatientPage(task.customerId)"
                                >
                                    <customer-card
                                        :customer="task.customer"
                                    ></customer-card>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <button class="btn" v-if="currentTask == index">
                            <i class="fe fe-chevron-down"></i>
                        </button>
                        <button class="btn" v-else>
                            <i class="fe fe-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body p-3" v-if="index == currentTask">
                <hr class="mt-2" />
                <div class="row">
                    <div class="col-12 col-md mb-3 mb-md-0 d-flex align-items-center">
                        <i class="fe fe-message-circle mr-3" v-if="task.note" />
                        {{ task.note }}
                    </div>
                    <div class="col-12 col-md-auto text-right">
                        <button
                            class="btn mr-3 btn-outline-primary"
                            v-b-tooltip
                            :title="$t('Create appointment')"
                            @click="openAppointmentModal(task)"
                        >
                            <i class="fe fe-calendar"></i>
                        </button>

                        <confirmable-button
                            v-if="task.status !== 'cancelled'"
                            style="display:inline-block"
                            class="mr-3 border-danger"
                            v-b-tooltip
                            @confirm="setTaskStatus(task, 'cancelled')"
                            :title="$t('Cancel')"
                        >
                            <i class="fe fe-x-circle text-danger"></i>
                        </confirmable-button>

                        <button
                            v-if="task.status !== 'completed'"
                            class="btn mr-3 btn-outline-success"
                            @click="setTaskStatus(task, 'completed')"
                            v-b-tooltip
                            :title="$t('Done')"
                        >
                            <i class="fe fe-check"></i>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12" v-if="task.initial">
                        <span class="small text-muted">{{ $t("Treatment received") }}:</span>
                        <div
                            class="row mb-1"
                            v-for="initial in task.initial"
                            :key="initial._id"
                        >
                            <div class="col">
                                <span v-if="initial.treatment">{{ initial.treatment.label }}</span>
                            </div>
                            <div class="col-auto">
                                <user :user="initial.userId" :avatar="true"></user>
                            </div>
                        </div>
                        <!-- <a href="#" @click="view(task)" class="btn btn-sm btn-primary">Subscribe</a> -->
                    </div>
                    <div
                        class="col"
                        v-if="task.upcoming && task.type === 'TREATMENT_REMINDER'"
                    >
                        <span class="small text-muted">{{ $t("Upcoming treatment") }}:</span>
                        <div
                            class="row mb-1 px-3"
                            v-for="upcoming in task.upcoming"
                            :key="upcoming._d"
                        >
                            <span v-if="upcoming.treatment">{{ upcoming.treatment.label }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { modalMixins } from "@/mixins/modal.js";
import { mapActions } from "vuex";
import ConfirmableButton from "@/components/ConfirmableButton";
import StatusBadge from "@/Pages/Company/Tasks/StatusBadge";
import LabModal from "@/Pages/Company/Labs/LabModal";
import PrintLabModal from "@/Pages/Company/Labs/PrintLabModal";
import RemoveModal from "@/Pages/Company/Labs/RemoveModal";
import CustomerCard from "@/components/CustomerCard.vue";
import User from "@/components/User.vue";

export default {
    mixins: [modalMixins],
    props: {
        tasks: {
            type: Array,
            required: true
        },
        hideCustomer: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false,
        },
        openAppointmentModal: {
            type: Function
        }
    },
    components: {
        User,
        ConfirmableButton,
        StatusBadge,
        LabModal,
        PrintLabModal,
        RemoveModal,
        CustomerCard
    },

    data() {
        return {
            data: {},
            currentTask: 0
        };
    },
    methods: {
        ...mapActions("tasks", { patch: "patch" }),

        openPatientPage(customerId) {
            this.$router.push({
                name: "people.customer",
                params: { id: customerId }
            });
        },

        openAppointmentModalTask(task) {
            let data = {};
            if (task.customerId) {
                data.customerId = task.customerId;
            }
            if (task.upcoming) {
                data.startAt = task.startDate;
                data.services = task.upcoming.map(el => ({
                    user: el.userId,
                    treatment: el.treatment,
                    duration: el.treatment.duration,
                    quantity: 1
                }));
            }
            this.openModal({ id: "AppointmentFastModal" });
            const { Appointment } = this.$FeathersVuex;

            new Appointment({
                model: data,
                _id: "temp"
            });
        },

        setTaskStatus(task, status) {
            this.patch([task._id, { status: status }]);
            this.currentTask = 0;
        },

        isDueDate(dueDate) {
            return this.$moment(dueDate) <= this.$moment();
        }
    }
};
</script>
